import { isLoadingHandler } from '../Utils';

export const SET_DATA_TYPES = 'SET_DATA_TYPES';
export const IS_LOADING = 'DATA_TYPES_IS_LOADING';

const INITIAL_STATE = {
    isLoading: false,
    items: [],
};

const ACTION_HANDLERS = {
    [IS_LOADING]: isLoadingHandler,
    [SET_DATA_TYPES]: (state, { payload }) => ({
        ...state,
        items: payload.dataTypes,
    }),
};

export default (state = INITIAL_STATE, action) => {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
};



// WEBPACK FOOTER //
// ./src/store/reducers/dataTypes.js